import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../shared/services/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Jurisdiction } from '../../shared/models/jurisdiction';
import { JurisdictionService } from '../../shared/services/jurisdiction.service';
@Component({
    selector: 'xp-add-edit-jurisdiction',
    templateUrl: './add-edit-jurisdiction.component.html',
    styleUrl: './add-edit-jurisdiction.component.scss'
})
export class AddEditJurisdictionComponent {
    jurisdictionForm!: FormGroup;
    isEditMode: boolean = false;
    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: { data: Jurisdiction },
        public dialogRef: MatDialogRef<AddEditJurisdictionComponent>,
        private snackbarService: SnackbarService,
        private formBuilder: FormBuilder,
        private jurisdictionService: JurisdictionService) {
        this.isEditMode = data.data ? true : false;
        this.initializeForm();
    }

    initializeForm() {
        this.jurisdictionForm = this.formBuilder.group({
            juridictionName: ['', Validators.required],
            juridictionCode: ['', Validators.required],
            jurisdictionOrgKey: ['', Validators.required],
            dateFormat: [''],
        });

        if (this.isEditMode) {
            this.jurisdictionForm.patchValue({
                juridictionName: this.data.data.jurisdictionName,
                juridictionCode: this.data.data.jurisdictionCode,
                jurisdictionOrgKey: this.data.data.jurisdictionOrgKey,
                dateFormat: this.data.data.dateFormat,
            });
        }
    }

    async onSubmit() {
        if (this.jurisdictionForm.invalid) {
            return;
        }
            const payload: Jurisdiction = {
                id: this.data?.data?.id ?? 0,
                jurisdictionName: this.jurisdictionForm.get('juridictionName')?.value,
                jurisdictionCode: this.jurisdictionForm.get('juridictionCode')?.value,
                jurisdictionOrgKey: this.jurisdictionForm.get('jurisdictionOrgKey')?.value,
                dateFormat: this.jurisdictionForm.get('dateFormat')?.value
            }

            if (this.isEditMode) {
                try {
                    await this.jurisdictionService.updateJurisdiction(this.data.data.id, payload)
                    this.snackbarService.successSnackBar("Jurisdiction Updated Successfully");
                }
                catch (e: any) {
                    if (e.status === 409) {
                        this.snackbarService.errorSnackBar("Jurisdiction Org Key is already present.");
                    } else {
                        this.snackbarService.errorSnackBar("Error while updating Jurisdiction");
                    }
                }
            }
            else {
                try {
                    await this.jurisdictionService.createJurisdiction(payload)
                    this.snackbarService.successSnackBar("Jurisdiction Created Successfully");
                } catch (e: any) {
                    if (e.status === 409) {
                        this.snackbarService.errorSnackBar("Jurisdiction Org Key is already present.");
                    } else {
                        this.snackbarService.errorSnackBar("Error while creating Jurisdiction");
                    }
                }
            }
            await this.dialogRef.close(true);

    }
}
